module.exports = __webpack_public_path__ + "static/media/demi.a0a61ba7.webp";